// extracted by mini-css-extract-plugin
export default {"container":"profile_container__JdsAT","headerContainer":"profile_headerContainer__HL0Hg","homeButton":"profile_homeButton__gU7M5","homeIcon":"profile_homeIcon__84+uB"};